import { useState } from "react"
import gpraStyles from "../../../styles/Participant-GPRA.module.css"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import GpraNotElegible from "../GpraNotElegible/GpraNotElegible"
import { DateTime } from "luxon"
import { Tooltip } from "primereact/tooltip"

const CreateGpraRecord = ({
  staff_id,
  organization_id,
  membership_uuid,
  participant_uuid,
  participant_id,
  organization_alias,
  participant_name,
  organization_name,
  setReloadStatus,
  program_list,
  inactiveParticipant,
  ableToCreate,
  dischargeStartDate,
  recordStatus,
}) => {
  const [confirmation, setConfirmation] = useState()

  const setLegend = () => {
    let legend = ""
    if (recordStatus !== "Complete") {
      legend += "There is already an active record."
    } else {
      if (!ableToCreate) {
        legend += "Unable to create a record - "
        if (dischargeStartDate) {
          const date = DateTime.fromISO(dischargeStartDate, {
            zone: "utc",
          })
            .toLocal()
            .plus({ days: 30 })
            .toLocaleString()
          if (date.year !== 0) {
            legend +=
              "You are within the 30-day restriction period. The restriction period ends on " +
              date
          }
        }
      }
    }
    return legend
  }
  return (
    <div className={gpraStyles.createRecordContainer}>
      <p
        style={{
          display: "inline-block",
        }}
      ></p>
      <div
        className={gpraStyles.interviewCardButton}
        style={{ paddingRight: "0rem" }}
      >
        {!ableToCreate && (
          <>
            <Tooltip
              target=".custom-target-icon-create"
              position="left"
              className="custom-tooltip"
            >
              <p style={{ fontSize: "16px" }}>
                <i>{setLegend()}</i>
              </p>
            </Tooltip>
            <i
              className={`${"custom-target-icon-create pi pi-envelope p-text-secondary pi-info-circle"} ${
                gpraStyles.interviewCardButtonTooltipIcon
              }`}
            ></i>
          </>
        )}
        <Button
          label="Create GPRA Record"
          disabled={!ableToCreate}
          className={gpraStyles.interviewStatusCardButton}
          onClick={() => {
            setConfirmation(true)
          }}
        />
        <Dialog
          visible={confirmation}
          onHide={() => setConfirmation(false)}
          className={gpraStyles.createRecordConfirmationDialog}
          modal
          header={"Create GPRA Record"}
        >
          <GpraNotElegible
            staff_id={staff_id}
            organization_id={organization_id}
            membership_uuid={membership_uuid}
            participant_uuid={participant_uuid}
            participant_id={participant_id}
            organization_alias={organization_alias}
            participant_name={participant_name}
            organization_name={organization_name}
            setReloadStatus={setReloadStatus}
            programs_list={program_list}
            inactiveParticipant={inactiveParticipant}
            showMessage={false}
          />
        </Dialog>
      </div>
    </div>
  )
}
export default CreateGpraRecord
